<template>
  <v-card min-width="400">
    <v-row align="center" justify="center" class="ma-0">
      <v-col cols="12" sm="4" align="center" class="ma-0">
        <v-avatar icon size="100" class="mt-2 mb-2">
          <v-img
            v-if="$auth.user.profile_photo_thumbnail"
            :src="$auth.user.profile_photo_thumbnail"
          ></v-img>
          <v-img v-else :src="$auth.user.picture"></v-img>
        </v-avatar>
      </v-col>
      <v-col cols="12" sm="8" align="start" class="ma-0">
        <v-row>
          <v-list style="max-width: 400px !important">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  style="
                    white-space: normal;
                    word-break: break-word;
                    line-height: normal;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                  "
                >
                  {{ $auth.user.tenantUserName || $auth.user.name }}
                </v-list-item-title>

                <v-list-item-subtitle
                  ><v-icon color="appMenu">mdi-email</v-icon
                  >{{ $auth.user.email }}</v-list-item-subtitle
                >

                <v-list-item-subtitle v-if="userInfo">
                  <v-icon color="appMenu">mdi-facebook-workplace</v-icon
                  >{{ userInfo.jobTitle }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="userInfo"
                  ><v-icon color="appMenu">mdi-phone</v-icon
                  >{{ userInfo.businessPhones[0] }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="userInfo">
                  <v-icon color="appMenu">mdi-map-marker</v-icon
                  >{{ userInfo.officeLocation }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="!timerPage" class="mb-2">
                  <strong>{{ $t("lblTenant") }}:</strong> {{ tenantName
                  }}<v-menu
                    v-if="false"
                    bottom
                    right
                    offset-y
                    :menu-props="{ bottom: true, offsetY: true }"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        dark
                        icon
                        color="grey"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-2"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item-group
                        v-model="listSelection"
                        color="pageHeader"
                      >
                        <v-list-item v-for="(item, i) in tenantItems" :key="i">
                          <!-- <template v-slot:default="{ active }"> -->
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <!-- </template> -->
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </v-list-item-subtitle>

                <v-list-item-subtitle style="white-space: normal !important">
                  <strong> {{ $t("admin.lblGeneralRoles") }} :</strong>
                  <template v-for="item in generalRoles">
                    <v-chip
                      x-small
                      color="primary"
                      class="ml-1"
                      :key="item.role_id"
                    >
                      {{ item.role_name }}
                    </v-chip>
                  </template>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-row>
      </v-col>
    </v-row>
    <v-row align="center" justify="start" class="ma-0 pl-4">
      <span
        class="font-weight-bold"
        style="color: rgba(0, 0, 0, 0.6); font-size: 14px"
        >{{ $t("admin.lblMeetingBasedRoles") }} :</span
      >
    </v-row>
    <v-row align="center" justify="center" class="ma-0 pb-4">
      <a-data-table
        style="width: 490px !important"
        v-model="selectedMeetingType"
        :headers="headers"
        :items="roleAssignedList"
        class="role-table elevation-1"
        item-key="meeting_type_id"
        hide-default-footer
        :no-data-text="$t('noData')"
        :loading-text="$t('LoaderText')"
        mobile-breakpoint="0"
        disable-pagination
        disable-sort
        dense
        single-select
        fixed-header
      >
        <template v-slot:[`header.meeting_type_name`]="{ header }">
          <span class="header-text"> {{ header.text }}</span>
        </template>
        <template v-slot:[`header.role_name`]="{ header }">
          <span class="header-text"> {{ header.text }} </span>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.meeting_type_name }}</td>
            <td>{{ item.role_name }}</td>
          </tr>
        </template>
      </a-data-table>
    </v-row>

    <v-divider></v-divider>
    <v-banner color="appBarT" v-if="!timerPage">
      <v-card-actions>
        <v-btn color="appMenu" text @click="onChangePassword()"
          ><v-icon>mdi-lock</v-icon> {{ $t("changePassword") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="appMenu" text @click="logout()"
          ><v-icon>mdi-logout-variant</v-icon> {{ $t("logout") }}
        </v-btn>
      </v-card-actions>
    </v-banner>
  </v-card>
</template>
<style scoped>
.role-table /deep/ .v-data-table__wrapper {
  max-height: 130px !important;
}
::v-deep .v-banner__wrapper {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  padding: 0px !important;
}
</style>
<script>
export default {
  name: "LoggedInUser",
  props: {
    userInfo: Object,
  },
  data() {
    return {
      profilePhoto: null,
      tenantItems: [],
      selectedMeetingType: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("admin.lblMeetingType"),
          value: "meeting_type_name",
          align: "left",
          class: "header",
        },
        {
          text: this.$t("admin.lblAssignedRole"),
          value: "role_name",
          align: "left",
          class: "header",
        },
      ];
    },
    timerPage() {
      if (this.$route.path.startsWith("/meetingTimer/")) {
        return true;
      } else {
        return false;
      }
    },
    tenantName() {
      if (this.selectedTenant) {
        return this.selectedTenant.name;
      }
      return "";
    },
    listSelection: {
      get() {
        return this.tenantItems.findIndex(
          (t) => t.id === sessionStorage.getItem("tenantId")
        );
      },
      set(value) {
        sessionStorage.setItem("tenantId", this.tenantItems[value].id);
        localStorage.setItem("tenantId", this.tenantItems[value].id);
        // window.location.reload();
        if (this.$route.path === "/forbidden" || this.$route.path !== "/") {
          this.$router.push({ path: "/" });
          this.$router.go();
        } else {
          this.$router.go();
        }
      },
    },
    selectedTenant: {
      get() {
        return this.tenantItems.find(
          (t) => t.id === sessionStorage.getItem("tenantId")
        );
      },
      set(value) {
        sessionStorage.setItem("tenantId", value.id);
        localStorage.setItem("tenantId", value.id);
      },
    },
    generalRoles() {
      return this.$auth.user.general_roles || [];
    },
    roleAssignedList() {
      const roleList = this.$auth.user.meeting_type_roles || [];
      return roleList.filter(
        (m) => m.meeting_type_name !== null && m.role_name !== null
      );
    },
  },
  watch: {
    "$auth.user": {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          this.tenantItems =
            this.$auth.user[process.env.VUE_APP_TENANT_KEY] || [];
        }
      },
    },
  },
  methods: {
    logout() {
      this.$auth.logout();
      // this.$router.push({ path: "/" }); // Line comment by Hitesh on 09/111/2022
    },
    onChangePassword() {
      this.$emit("changePassword");
    },
  },
};
</script>
